export default __webpack_public_path__ + "static/media/best-student-paper_EAAFSSM_small.a305fb0d.png";